export default __webpack_public_path__ + "static/media/yellow-watch.8c2b73da.svg";